console.log(process.env.NODE_ENV);
export default {
  // 维护接口地址，如果有其他地址需要可以在这里列出来 在需要到的地方引用
  requestURL:
    process.env.NODE_ENV === "development" ? "/apis" : "http://yy.jxcvip.cn/"
};
